@if (accessToFooter) {
  <div class="footer row h-100 pt-1 pb-1 ps-5 pe-5 m-0">
    <div class="col-md-10 d-flex flex-md-row align-items-center flex-sm-column m-sm-3 m-md-0">
      <div *appNotLoggedIn>
        <app-menu #languageTemplate>
          @for (lang of supportedLangs; track lang) {
            <div class="d-flex justify-content-start align-items-center cursor-pointer">
              <a
                class="btn btn-sm btn-ghost-ghost"
                style="width: 100% !important; padding: 0.5rem 0.5rem; display: flex"
                (click)="onLangChange(lang); MenuTrigger.closeMenu()"
              >
                <img
                  style="margin-right: 1rem"
                  src="assets/images/flags/{{ lang.flag }}.png"
                  alt="{{ 'RGAA.LOGIN.FLAG_' + (lang.langId | uppercase) + '_ALT' | translate }}"
                />
                <span>{{ lang.label }}</span>
              </a>
            </div>
          }
        </app-menu>
        <div [appMenuTrigger]="languageTemplate" #MenuTrigger="MenuTrigger" class="ico-dropdown">
          <img
            src="assets/images/flags/{{ selectedLang.flag }}.png"
            alt="{{ 'RGAA.LOGIN.FLAG_' + (selectedLang.langId | uppercase) + '_ALT' | translate }}"
          />
          <i class="icon-chevron-down" style="font-size: 1rem" aria-hidden="true"></i>
        </div>
      </div>
      <nav role="navigation">
        <ul style="display: flex; margin: 0px">
          <li>
            <button
              class="btn btn-sm p-0 ms-md-2 btn-ghost-ghost fw-bolder p-sm-1 m-md-0 m-sm-1 mt-sm-3"
              (click)="openLegalNoticeModal()"
            >
              <span class="text-ultramarine fw-normal fs-xs pe-2 ps-2"> {{ 'FOOTER.LEGAL_NOTICES' | translate }}</span>
            </button>
          </li>
          <li>
            <button class="btn btn-sm p-0 btn-ghost-ghost fw-bolder p-sm-1 m-sm-1 m-md-0" (click)="openCGUModal()">
              <span class="text-ultramarine fw-normal fs-xs pe-2 ps-2"> {{ 'FOOTER.CGU' | translate }}</span>
            </button>
          </li>
          <li>
            <a
              class="btn btn-sm p-0 btn-ghost-ghost fw-bolder p-sm-1 m-sm-1 m-md-0"
              href="https://docaposte.elium.com/public/content/Vy_SbweB3j-IB4s8HOe2VapwfUR-1Z3rgdwO9sE8nNw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="text-ultramarine fw-normal fs-xs pe-2 ps-2"> {{ 'FOOTER.ACCESSIBILITY' | translate }}</span>
            </a>
          </li>
        </ul>
      </nav>
      <span class="text-ultramarine fw-normal fs-xs pe-2 ps-2"> {{ 'V' + appVersion }}</span>
      <img
        class="d-md-none d-sm-bloc mt-2"
        src="assets/images/trust_doca_logo.png"
        alt="{{ 'RGAA.LOGIN.LOGO_TECH_TRUST_DOCAPOSTE_ALT' | translate }}"
      />
    </div>
    <div class="col-md-2 d-flex flex-row justify-content-end d-sm-none d-md-flex">
      <img
        src="assets/images/trust_doca_logo.png"
        alt="{{ 'RGAA.LOGIN.LOGO_TECH_TRUST_DOCAPOSTE_ALT' | translate }}"
        style="height: 40px"
      />
    </div>
  </div>
}
